import { MultiPolygon, Polygon, Position } from 'geojson';

export const POLYGON_VALID: Polygon = {
  type: 'Polygon',
  coordinates: [
    [
      [0, 0],
      [10, 10],
      [20, 20],
      [0, 0],
    ],
  ],
};
export const POLYGON_WITH_INVALID_POINT: Polygon = {
  type: 'Polygon',
  coordinates: [
    [
      [0, 0],
      [10, 390],
      [20, 20],
      [0, 0],
    ],
  ],
};
export const POLYGON_NOT_CLOSED: Polygon = {
  type: 'Polygon',
  coordinates: [
    [
      [0, 10],
      [10, 10],
      [20, 20],
      [0, 0],
    ],
  ],
};

export const POLYGON_VALID_COMPLEX: Polygon = {
  type: 'Polygon',
  coordinates: [
    [
      [2.359219845726463, 48.745212764515486],
      [2.364570852711174, 48.74462467770937],
      [2.3649329509281842, 48.74242702926466],
      [2.361841705038521, 48.74165318651416],
      [2.3628408278965685, 48.74318317267185],
      [2.359917220070335, 48.74328929715196],
      [2.360567655756447, 48.74422229856117],
      [2.359219845726463, 48.745212764515486],
    ],
  ],
};

export const POLYGON_VALID_COMPLEX_MARGIN: Polygon = {
  type: 'Polygon',
  coordinates: [
    [
      [2.3584976773089728, 48.74547449359238],
      [2.3648189489771276, 48.74477978905253],
      [2.3652261928419147, 48.74230806183113],
      [2.361337315244765, 48.74133453679988],
      [2.3624364241994718, 48.74301767018193],
      [2.3595025406197605, 48.74312415759823],
      [2.3602455911942783, 48.74419002376672],
      [2.3584976773089728, 48.74547449359238],
    ],
  ],
};

export const POLYGON_VALID_COMPLEX_MARGIN_DIFF: Position[][] = [
  [
    [2.3584976773089728, 48.74547449359238],
    [2.3602455911942783, 48.74419002376672],
    [2.3595025406197605, 48.74312415759823],
    [2.3624364241994718, 48.74301767018193],
    [2.361337315244765, 48.74133453679988],
    [2.3652261928419147, 48.74230806183113],
    [2.3648189489771276, 48.74477978905253],
    [2.3584976773089728, 48.74547449359238],
  ],
  [
    [2.359219845726463, 48.745212764515486],
    [2.364570852711174, 48.74462467770937],
    [2.3649329509281842, 48.74242702926466],
    [2.361841705038521, 48.74165318651416],
    [2.3628408278965685, 48.74318317267185],
    [2.359917220070335, 48.74328929715196],
    [2.360567655756447, 48.74422229856117],
    [2.359219845726463, 48.745212764515486],
  ],
];

export const POLYGON_3D_VALID: MultiPolygon = {
  type: 'MultiPolygon',
  coordinates: [
    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 1, 0],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [0, 0, 1],
        [0, 1, 1],
        [1, 1, 1],
        [1, 0, 1],
        [0, 0, 1],
      ],
    ],
    [
      [
        [0, 0, 0],
        [0, 0, 1],
        [0, 1, 1],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [1, 0, 0],
        [1, 1, 0],
        [1, 1, 1],
        [1, 0, 1],
        [1, 0, 0],
      ],
    ],
    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 0, 1],
        [0, 0, 1],
        [0, 0, 0],
      ],
    ],
    [
      [
        [0, 1, 0],
        [0, 1, 1],
        [1, 1, 1],
        [1, 1, 0],
        [0, 1, 0],
      ],
    ],
  ],
};

export const POLYGON_3D_VALID_2D_RAW_PROJECTION: Position[] = [
  [0, 0],
  [1, 0],
  [1, 1],
  [0, 1],
  [0, 0],
  [0, 0],
  [0, 1],
  [1, 1],
  [1, 0],
  [0, 0],
  [0, 0],
  [0, 0],
  [0, 1],
  [0, 1],
  [0, 0],
  [1, 0],
  [1, 1],
  [1, 1],
  [1, 0],
  [1, 0],
  [0, 0],
  [1, 0],
  [1, 0],
  [0, 0],
  [0, 0],
  [0, 1],
  [0, 1],
  [1, 1],
  [1, 1],
  [0, 1],
];

export const POLYGON_3D_WITH_INVALID_POINT: MultiPolygon = {
  type: 'MultiPolygon',
  coordinates: [
    [
      [
        [0, 0, 1],
        [10, 390, 1],
        [20, 20, 1],
        [0, 0, 1],
        [0, 0, 1],
      ],
    ],
    [
      [
        [0, 0, 1],
        [0, 1, 1],
        [1, 1, 1],
        [1, 0, 1],
        [0, 0, 1],
      ],
    ],
    [
      [
        [0, 0, 0],
        [0, 0, 1],
        [0, 1, 1],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [1, 0, 0],
        [1, 1, 0],
        [1, 1, 1],
        [1, 0, 1],
        [1, 0, 0],
      ],
    ],
    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 0, 1],
        [0, 0, 1],
        [0, 0, 0],
      ],
    ],
    [
      [
        [0, 1, 0],
        [0, 1, 1],
        [1, 1, 1],
        [1, 1, 0],
        [0, 1, 0],
      ],
    ],
  ],
};

export const POLYGON_3D_NOT_CLOSED: MultiPolygon = {
  type: 'MultiPolygon',
  coordinates: [
    [
      [
        [0, 0, 1],
        [0, 1, 1],
        [1, 1, 1],
        [1, 0, 1],
        [0, 0, 1],
      ],
    ],
    [
      [
        [0, 0, 0],
        [0, 0, 1],
        [0, 1, 1],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [1, 0, 0],
        [1, 1, 0],
        [1, 1, 1],
        [1, 0, 1],
        [1, 0, 0],
      ],
    ],

    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 0, 1],
        [0, 0, 1],
        [0, 0, 0],
      ],
    ],
    [
      [
        [0, 1, 0],
        [0, 1, 1],
        [1, 1, 1],
        [1, 1, 0],
        [0, 1, 0],
      ],
    ],
  ],
};

export const POLYGON_3D_WITHOUT_ALTITUDE: Position[] = [
  [0, 0],
  [1, 0],
  [1, 1],
  [0, 1],
  [0, 0],

  [0, 0],
  [0, 1],
  [1, 1],
  [1, 0],
  [0, 0],

  // Tant qu'ils sont entre 0 et 1, ces points doivent être supprimés par le convexHull dans notre exemple
  [0.1, 0.5],
  [0.4, 0.6],
  [0.9, 0.8],
  [0.6, 0.2],

  [0, 0],
  [0, 0],
  [0, 1],
  [0, 1],
  [0, 0],

  [1, 0],
  [1, 1],
  [1, 1],
  [1, 0],
  [1, 0],

  [0, 0],
  [1, 0],
  [1, 0],
  [0, 0],
  [0, 0],

  [0, 1],
  [0, 1],
  [1, 1],
  [1, 1],
  [0, 1],
];

// Cube penché, forme une rampe (la face haute se construit entre (2 2 1) et (3 3 1))
export const POLYGON_3D_VALID_COMPLEX_LEANING_CUBE: MultiPolygon = {
  type: 'MultiPolygon',
  coordinates: [
    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [1, 1, 0],
        [0, 1, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [0, 0, 0],
        [2, 2, 1],
        [3, 2, 1],
        [1, 0, 0],
        [0, 0, 0],
      ],
    ],
    [
      [
        [1, 0, 0],
        [3, 2, 1],
        [3, 3, 1],
        [1, 1, 0],
        [1, 0, 0],
      ],
    ],

    [
      [
        [0, 1, 0],
        [1, 1, 0],
        [3, 3, 1],
        [2, 3, 1],
        [0, 1, 0],
      ],
    ],
    [
      [
        [0, 0, 0],
        [0, 1, 0],
        [2, 3, 1],
        [2, 2, 1],
        [0, 0, 0],
      ],
    ],
    [
      [
        [2, 2, 1],
        [3, 2, 1],
        [3, 3, 1],
        [2, 3, 1],
        [2, 2, 1],
      ],
    ],
  ],
};

export const POLYGON_3D_VALID_COMPLEX_LEANING_CUBE_RAW_PROJECTION: Position[] = [
  [0.0, 0.0],
  [1.0, 0.0],
  [1.0, 1.0],
  [0.0, 1.0],
  [0.0, 0.0],

  [0.0, 0.0],
  [2.0, 2.0],
  [3.0, 2.0],
  [1.0, 0.0],
  [0.0, 0.0],

  [1.0, 0.0],
  [3.0, 2.0],
  [3.0, 3.0],
  [1.0, 1.0],
  [1.0, 0.0],

  [0.0, 1.0],
  [1.0, 1.0],
  [3.0, 3.0],
  [2.0, 3.0],
  [0.0, 1.0],

  [0.0, 0.0],
  [0.0, 1.0],
  [2.0, 3.0],
  [2.0, 2.0],
  [0.0, 0.0],

  [2.0, 2.0],
  [3.0, 2.0],
  [3.0, 3.0],
  [2.0, 3.0],
  [2.0, 2.0],
];

// Forme d'hexagone/cristal, vu de dessus ça a 6 faces
export const POLYGON_3D_VALID_HEXAGON: MultiPolygon = {
  type: 'MultiPolygon',
  coordinates: [
    // Face basse
    [
      [
        [0, 0, 0],
        [1, 0, 0],
        [2, 1, 0],
        [1, 2, 0],
        [0, 2, 0],
        [-1, 1, 0],
        [0, 0, 0],
      ],
    ],
    //Face haute
    [
      [
        [0, 0, 1],
        [1, 0, 1],
        [2, 1, 1],
        [1, 2, 1],
        [0, 2, 1],
        [-1, 1, 1],
        [0, 0, 1],
      ],
    ],
    // Face avant
    [
      [
        [0, 0, 0],
        [0, 0, 1],
        [1, 0, 1],
        [1, 0, 0],
        [0, 0, 0],
      ],
    ],
    // 2 faces droites
    [
      [
        [1, 0, 0],
        [1, 0, 1],
        [2, 1, 1],
        [2, 1, 0],
        [1, 0, 0],
      ],
    ],
    [
      [
        [2, 1, 0],
        [2, 1, 1],
        [1, 2, 1],
        [1, 2, 0],
        [2, 1, 0],
      ],
    ],
    // Face arrière
    [
      [
        [0, 2, 0],
        [1, 2, 0],
        [1, 2, 1],
        [0, 2, 1],
        [0, 2, 0],
      ],
    ],
    // 2 faces gauches
    [
      [
        [0, 0, 0],
        [-1, 1, 0],
        [-1, 1, 1],
        [0, 0, 1],
        [0, 0, 0],
      ],
    ],
    [
      [
        [-1, 1, 0],
        [0, 2, 0],
        [0, 2, 1],
        [-1, 1, 1],
        [-1, 1, 0],
      ],
    ],
  ],
};
